import React, { memo } from "react";
import { Loading as LoadingIcon } from "@op/opds.opux";

const Loading = memo(() => (
  <LoadingIcon id="ROF-loading" className="rof-loading" />
));

export default Loading;
